<template>
    <div data-cy="passwordConfig">
        <div v-if="onlyFields === 'true'">
            <br />

            <span class="notice" v-html="noticePwdRules"></span>

            <br />
            <br />

            {{ $t('passAccount.password.newPassword') }}
            <v-text-field
                color="#3200E6"
                :append-icon="showNewPwd ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                @click:append="() => (showNewPwd = !showNewPwd)"
                @keyup.native="checkIsValid()"
                :type="showNewPwd ? 'password' : 'text'"
                v-model="fields.newPwd"
                name="newPasswordReset"
                autocomplete="new-password"
                data-cy="newPassword"
            />

            {{ $t('passAccount.password.passwordValidation') }}
            <v-text-field
                color="#3200E6"
                :append-icon="showNewPwdValidation ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                @click:append="() => (showNewPwdValidation = !showNewPwdValidation)"
                @keyup.native="checkIsValid()"
                :type="showNewPwdValidation ? 'password' : 'text'"
                v-model="fields.validationPwd"
                name="newPasswordValidationReset"
                autocomplete="new-password"
                data-cy="newPasswordValidation"
            />

            <v-alert
                data-cy="wrongValidationWarning"
                v-if="!newPwdRuleWarning && wrongValidationWarning"
                dense
                outlined
                type="error"
            >
                {{ $t('passAccount.password.wrongValidationWarning') }}
            </v-alert>
            <v-alert data-cy="currPwdWarning" v-if="currPwdWarning" dense outlined type="error">
                {{ $t('passAccount.common.currPwdWarning') }}
            </v-alert>
            <v-alert id="ruleWarning" v-if="newPwdRuleWarning" dense outlined type="error">
                {{ $t('passAccount.password.newPwdRuleWarning') }}
            </v-alert>
        </div>
        <v-form @submit.prevent ref="form" v-else>
            <v-card class="tab-card">
                <v-container>
                    <v-card-title>{{ getPageTitle() }}</v-card-title>
                    <div v-if="page === 'lostpassword' && userInformations">
                        <v-card-text>
                            <table>
                                <tbody>
                                    <tr>
                                        <td class="key">{{ $t('passwordLost.change.my_id') }}</td>
                                        <td>{{ userInformations.geodisLogin }}</td>
                                    </tr>
                                    <tr>
                                        <td class="key">{{ $t('passwordLost.change.firstname') }}</td>
                                        <td>{{ userInformations.firstname }}</td>
                                    </tr>
                                    <tr>
                                        <td class="key">{{ $t('passwordLost.change.lastname') }}</td>
                                        <td>{{ userInformations.lastname }}</td>
                                    </tr>
                                    <tr>
                                        <td class="key">{{ $t('passwordLost.change.mail') }}</td>
                                        <td>{{ userInformations.mail }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-card-text>
                    </div>
                    <div v-else>
                        <v-card-text>
                            <b>
                                <small><span class="notice" v-html="noticePwdModifyPage"></span></small>
                            </b>
                        </v-card-text>
                        <v-card-text>
                            {{ $t('passAccount.common.currentPassword') }}
                            <v-text-field
                                color="#3200E6"
                                :append-icon="showPwd ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                @click:append="() => (showPwd = !showPwd)"
                                :type="showPwd ? 'password' : 'text'"
                                v-model="fields.currentPwd"
                                name="currentPassword"
                                data-cy="currentPassword"
                            />
                        </v-card-text>
                    </div>

                    <v-card-text>
                        <small><span class="notice" v-html="noticePwdRules"></span></small>
                    </v-card-text>

                    <br />

                    <v-card-text>
                        {{ $t('passAccount.password.newPassword') }}
                        <v-text-field
                            color="#3200E6"
                            :append-icon="showNewPwd ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                            @click:append="() => (showNewPwd = !showNewPwd)"
                            :type="showNewPwd ? 'password' : 'text'"
                            v-model="fields.newPwd"
                            name="newPassword"
                            data-cy="newPassword"
                        />
                    </v-card-text>

                    <v-card-text>
                        {{ $t('passAccount.password.passwordValidation') }}
                        <v-text-field
                            color="#3200E6"
                            :append-icon="showNewPwdValidation ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                            @click:append="() => (showNewPwdValidation = !showNewPwdValidation)"
                            :type="showNewPwdValidation ? 'password' : 'text'"
                            v-model="fields.validationPwd"
                            name="newPasswordValidation"
                            data-cy="newPasswordValidation"
                        />
                    </v-card-text>
                    <v-card-text>
                        <v-alert
                            v-if="!newPwdRuleWarning && wrongValidationWarning"
                            dense
                            outlined
                            type="error"
                            data-cy="wrongValidationWarning"
                        >
                            {{ $t('passAccount.password.wrongValidationWarning') }}
                        </v-alert>
                        <v-alert v-if="currPwdWarning" dense outlined type="error" data-cy="currPwdWarning">
                            {{ $t('passAccount.common.currPwdWarning') }}
                        </v-alert>
                        <v-alert v-if="newPwdRuleWarning" dense outlined type="error" data-cy="newPwdRuleWarning">
                            {{ $t('passAccount.password.newPwdRuleWarning') }}
                        </v-alert>
                    </v-card-text>
                    <v-card-text>
                        <div class="actions">
                            <v-btn data-cy="saveNewPasswordButton" :disabled="!isValid" class="action" @click="submit">
                                {{ $t('global.saveButton') }}
                            </v-btn>
                            <v-btn
                                data-cy="cancelButtonLostPassword"
                                class="secondary-action"
                                @click="cancelPwdChange"
                                v-if="page === 'lostpassword'"
                            >
                                {{ $t('passwordLost.prev') }}
                            </v-btn>
                            <v-btn class="secondary-action" @click="cancelPwdChange" v-else data-cy="cancelChangePassword">
                                {{ $t('global.cancelButton') }}
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-container>
            </v-card>
        </v-form>
        <v-snackbar v-model="snackbar.display" :timeout="snackbar.timeout" id="passwordTabSnackbar">
            {{ snackbar.text }}
        </v-snackbar>
    </div>
</template>

<script>
import { api } from '@utils/api';
import { i18n } from '@plugins/vuetify';

export default {
    props: ['page', 'onlyFields', 'isConfiguration'],
    data() {
        return {
            fields: {
                currentPwd: '',
                newPwd: '',
                validationPwd: '',
                lostpassword: false,
                resetpassword: false,
                geodisLogin: null
            },
            snackbar: {
                display: false,
                text: '',
                timeout: 2000
            },
            showPwd: 'password',
            showNewPwd: 'password',
            showNewPwdValidation: 'password',
            pwdRegexp: null,
            userInformations: null
        };
    },
    methods: {
        getPageTitle() {
            if (this.page === 'lostpassword') {
                return i18n.t('passwordLost.title');
            }
            return i18n.t('passAccount.header.changePassword');
        },
        cancelPwdChange() {
            if (this.page === 'lostpassword') {
                this.$router.push('/password-lost/secret-questions');
            } else {
                this.$router.push('/accMgmt');
            }
        },
        clearForm() {
            this.fields.newPwd = this.fields.validationPwd = '';
            if (this.page !== 'lostpassword') {
                this.fields.currentPwd = '';
            }
        },
        async submit() {
            this.$session.start();
            const data = {
                currentPassword: this.fields.currentPwd,
                newPassword: this.fields.newPwd,
                lostpassword: this.fields.lostpassword,
                resetpassword: this.fields.resetpassword,
                geodisLogin: this.fields.geodisLogin,
                isConfiguration: this.isConfiguration
            };

            if (this.$session.get('passwordlost-data')) {
                const pwdData = JSON.parse(atob(this.$session.get('passwordlost-data')));
                if (pwdData) {
                    data.geodisLogin = pwdData.userInformations.geodisLogin;
                }
            }

            const result = await api.patch('pwdChange', data, null, 'accMgmt');
            if (this.onlyFields === 'true') {
                return this.$emit('password-changed', result);
            }
            if (result) {
                if (this.page === 'lostpassword') {
                    return this.$router.push('/password-lost/changed');
                }
                this.snackbar.text = i18n.t('passAccount.password.passwordChanged');
                this.snackbar.display = true;
                this.$session.remove('passwordlost-data');
            } else {
                this.snackbar.text = i18n.t('passAccount.common.wrongCurrPwd');
                this.snackbar.display = true;
            }
            this.clearForm();
        },
        checkIsValid() {
            const check =
                this.fields.currentPwd &&
                this.fields.newPwd &&
                this.pwdRegexp.test(this.fields.newPwd) &&
                this.fields.validationPwd === this.fields.newPwd;
            this.$emit('password-is-valid', check);
            return check;
        }
    },
    computed: {
        noticePwdRules: function () {
            const notices = this.$store.getters.getNoticesPerId(2);
            const currentLang = this.$i18n.locale;
            const notice = notices.filter(notice => notice.language === currentLang);
            return notice[0]?.webTextContent;
        },
        noticePwdModifyPage: function () {
            const branch = this.$store.getters.getUserInformations?.userInfo?.branch;

            if (branch === 'People') {
                const notices = this.$store.getters.getNoticesPerId(1);
                const currentLang = this.$i18n.locale;
                const notice = notices.filter(notice => notice.language === currentLang);
                return notice[0]?.webTextContent;
            }
            return '';
        },
        isValid: function () {
            return this.checkIsValid();
        },
        currPwdWarning: function () {
            return this.fields.newPwd && !this.fields.currentPwd;
        },
        wrongValidationWarning: function () {
            if (this.fields.newPwd && this.fields.validationPwd && this.fields.validationPwd !== this.fields.newPwd) {
                return true;
            }
            return false;
        },
        newPwdRuleWarning: function () {
            if (this.fields.newPwd && !this.pwdRegexp.test(this.fields.newPwd)) {
                return true;
            }
            return false;
        }
    },
    async mounted() {
        const pwdConfig = await api.get('getPwdConfig', null, { withCredentials: true }, 'administration');

        if (pwdConfig) {
            this.pwdRegexp = new RegExp(
                `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#\\$\\^\\-\\]\\[${pwdConfig.specialChars.replace(
                    /[.*+?^${}()|[\]\\]/g,
                    '\\$&'
                )}]).{${pwdConfig.pwdLength},}$`
            );
        } else {
            this.pwdRegexp = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#\\$\\^\\-\\]\\[+=!?*()@%&_{}~|.]).{12,}$');
        }
        if (this.page === 'lostpassword') {
            const data = this.$session.get('passwordlost-data');

            if (data) {
                const informations = JSON.parse(decodeURIComponent(escape(atob(data))));
                this.userInformations = informations.userInformations;
            }

            const notices = await api.get('notices', null, { withCredentials: true }, 'accMgmt');
            if (notices) {
                this.$store.commit('setNotices', notices);
            }

            this.fields.lostpassword = true;
            this.fields.currentPwd = 'anonymous';
            this.fields.geodisLogin = this.userInformations && this.userInformations.geodisLogin;
        }
        if (this.onlyFields === 'true') {
            const notices = await api.get('notices', null, { withCredentials: true }, 'accMgmt');
            if (notices) {
                this.$store.commit('setNotices', notices);
            }

            this.fields.resetpassword = true;
            this.fields.currentPwd = 'anonymous';
            let informations = this.$session.get('accMgmt-configuration-informations');
            if (informations) {
                informations = JSON.parse(decodeURIComponent(escape(atob(informations))));
                this.fields.geodisLogin = informations.geodisLogin;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.service {
    cursor: pointer;
    border-top: 7px solid #fff;
    .v-card__subtitle {
        padding-top: 10px;
        padding-bottom: 21px;
    }
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
}
.v-text-field {
    width: 400px;
}

.actions {
    button {
        margin-right: 10px;
    }
}

.tab-card {
    margin: 20px 0px 0px 0;
}

.v-alert {
    width: 400px;
}

table {
    .key {
        padding-right: 40px;
    }
}
</style>
